import thunk from 'redux-thunk';
import logger from './logger';
import gateway from './gateway';

export default [
  thunk,
  logger,
  gateway
];
